export const normalizeInt = (v: string) => (v && parseInt(v, 10)) || 0
